import { CurrencyDollarIcon } from '@heroicons/react/outline';

export const PRIVACY_POLICY = 'https://www.jlrecharge.com/privacy-policy';
export const TERMS_OF_SERVICE = 'https://www.jlrecharge.com/terms-of-service';
export const VALIDATION_ERROR = 'validation_error';
export const PRODUCT_TYPES = {
  RECHARGE: 'recharge',
  BUNDLE: 'bundles',
};
export const APPLICATION_ID = {
  JLRECHARGE: 'jlrecharge',
  JLRSPACE: 'jlrspace',
};
export const PURCHASE_CREDIT = 'purchase_credit';
export const SELL_CREDIT = 'sell_credit';

// status
export const SUCCESS = 'success';
export const ERROR = 'error';
export const PENDING = 'pending';
export const UNKNOWN = 'unknown';
export const LOADING = 'loading';
export const LOADED = 'loaded';

export const StatsTypeIcons = {
  total_commision: CurrencyDollarIcon,
  total_purchases: CurrencyDollarIcon,
  total_sold: CurrencyDollarIcon,
};
